// const BASEURL = 'https://jonathankingcrm.herokuapp.com/api'
const BASEURL = 'https://api.jonathankingcrm.com/api'

export { BASEURL }

// MTBxAzxb - adegoketemitope
// H2jdybDY - xylia
